import actionTypes from "./../constants/actionTypes";
import { formatValueWithType } from "../utils/utility";
import { getList } from "./formActions";
import moment from "moment";
import dummyResponseJson from "./dummyResponse.json";
const dummyResponse = false;

const formListJson = (formPayload, listPayload, listMeta) => {
    const { data = {}, meta = {} } = formPayload;
    const { tradeList = [] } = listPayload;
    const { company = {} } = listMeta;
    const { section = [] } = data;
    const [firstSection = {}] = section;
    const { fields = [] } = firstSection;
    const listData = tradeList.map(trade => {
        const { companyId = '', buyQties = [], buyPrices = [], buyDates = [], sellDates = [], charges = {} } = trade;
        const { name = '', additionalInfo = {} } = company[companyId] || {};
        const { companyLink = '', nseCode = '' } = additionalInfo || {};
        const rowData = fields.reduce((accum, field, index) => {
            let value = '';
            switch (field.id) {
                case 'isAveraged': {
                    value = buyDates.length > 1 ? 'Yes' : 'No';
                    break;
                }
                case "averageData": {
                    value = buyDates.length > 1 ? buyDates.map((date, idx) => `${date} (Q.${buyQties[idx]} @ Rs.${buyPrices[idx]})`).join(', ') : 'N/A';
                    break;
                }
                case 'tradeCompleted': {
                    value = trade[field.id] ? 'Yes' : 'No';
                    break;
                }
                case "buyDate": {
                    value = buyDates[0];
                    break;
                }
                case "sellDate": {
                    value = sellDates[0];
                    break;
                }
                case 'averageData': {
                    value = trade[field.id] && trade[field.id].length > 0 ? trade[field.id].join(', ') : 'N/A';
                    break;
                }
                case 'moneyControlLink': {
                    value = { value: `${name} (${companyId}) [NSE:${nseCode}]`, link: companyLink };
                    break;
                }
                case 'grossProfitAmount': {
                    value = trade.tradeCompleted ? formatValueWithType(trade.totalSellAmount - trade.totalBuyAmount) : '';
                    break;
                }
                case 'profitPercentage': {
                    if (trade.tradeCompleted) {
                        const profitAmount = trade.tradeCompleted ? formatValueWithType(trade.totalSellAmount - trade.totalBuyAmount) : 0;
                        const buyAmount = trade.totalBuyAmount;
                        value = buyAmount > 0 ? formatValueWithType((profitAmount / buyAmount) * 100) : 0;
                    } else {
                        value = '';
                    }
                    break;
                }
                case 'dipDuringTradePercentage': {
                    const { lowestPriceDuringTrade = 0 } = trade;
                    const buyPrice = trade.buyPrices[0];
                    value = buyPrice > 0 ? formatValueWithType(((lowestPriceDuringTrade - buyPrice) / buyPrice) * 100) : 0;
                    break;
                }
                default: value = trade[field.id] ?? charges[field.id] ?? '';
            }
            return { ...accum, [field.id]: value };
        }, {});
        return rowData;
    });
    return { headers: fields, data: listData, meta };
}

const groupHoldingSession = (list) => {
    const ranges = [
        { min: 1, max: 30, label: '1M' },
        { min: 31, max: 60, label: '2M' },
        { min: 61, max: 90, label: '3M' },
        { min: 91, max: 180, label: '6M' },
        { min: 181, max: 270, label: '9M' },
        { min: 271, max: 360, label: '1Y' },
        { min: 361, max: 540, label: '1.5Y' },
        { min: 541, max: 720, label: '2Y' },
        { min: 721, max: 1080, label: '3Y' },
        { min: 1081, max: 1800, label: '5Y' },
        { min: 1801, max: Math.min(), label: '5Y-INF' }, // Adjust ranges as needed
    ];

    ranges.reverse();

    const rangeCounts = ranges.map((range, index) => {
        const count = list.filter(value => {
            return (value >= range.min && value <= range.max);
        }).length;
        return { range: `(${range.label}) ${range.min}-${range.max}`, count };
    });

    return rangeCounts;

}

const groupDateWise = (list, key = 'YYYY') => {
    const groupedList = Object.groupBy(list, (entry) => {
        const { buyDates = [] } = entry;
        return moment(buyDates[0], 'YYYY-MM-DD').format(key);
    });
    const finalResponse = Object.keys(groupedList).map(year => {
        const list = groupedList[year];
        let completedWithAverage = 0, completedWithoutAverage = 0, incompleteWithAverage = 0, incompleteWithoutAverage = 0;
        list.forEach(entry => {
            const { tradeCompleted = false, buyPrices = [] } = entry;
            const isAveraged = buyPrices.length > 1;
            if (tradeCompleted && isAveraged) completedWithAverage++
            else if (tradeCompleted && !isAveraged) completedWithoutAverage++;
            else if (!tradeCompleted && isAveraged) incompleteWithAverage++;
            else incompleteWithoutAverage++;
        });
        return { year, completedWithAverage, completedWithoutAverage, incompleteWithAverage, incompleteWithoutAverage };
    }).reduce((accum, data) => {
        const { year, ...restData } = data;
        return { [year]: restData, ...accum };
    }, {});

    return finalResponse;
}

const getMaxHoldingDuringATime = (list, groupKey = 'YYYY') => {
    let holding = {};
    const format = 'YYYY-MM-DD';
    const direction = 'asc';
    let newList = [];

    list.forEach(entry => {
        const postiveValue = entry.buyDates[0], negativeValue = entry.sellDates[0];

        if (postiveValue) {
            newList.push({ value: postiveValue, type: 'BUY' });
            const mapperKey = moment(postiveValue, format).format(groupKey);
            holding[mapperKey] = 0;
        }
        if (negativeValue) {
            newList.push({ value: negativeValue, type: 'SELL' });
            const mapperKey = moment(negativeValue, format).format(groupKey);
            holding[mapperKey] = 0;
        }

    });

    newList.sort((a, b) => {
        const aDate = moment(a.value, format);
        const bDate = moment(b.value, format);
        if (!aDate.isValid() && !bDate.isValid()) return 0;
        if (!aDate.isValid()) return direction === 'asc' ? 1 : -1;
        if (!bDate.isValid()) return direction === 'asc' ? -1 : 1;

        return direction === 'asc' ? aDate - bDate : bDate - aDate;
    });

    let count = 0;

    for (let tradeIndex = 0; tradeIndex < newList.length; tradeIndex++) {
        const { value = '', type = '' } = newList[tradeIndex];
        if (type === 'BUY')
            count++;
        else
            count--;
        const mapperKey = moment(value, format).format(groupKey);
        if (holding[mapperKey] < count)
            holding[mapperKey] = count;
    }

    newList = Object.keys(holding).map(key => ({ key, value: holding[key] }));

    newList.sort((a, b) => {
        const aDate = moment(a.key, groupKey);
        const bDate = moment(b.key, groupKey);
        if (!aDate.isValid() && !bDate.isValid()) return 0;
        if (!aDate.isValid()) return direction === 'asc' ? 1 : -1;
        if (!bDate.isValid()) return direction === 'asc' ? -1 : 1;

        return direction === 'asc' ? aDate - bDate : bDate - aDate;
    });

    // console.log("newList", newList);

    return newList;
}

const getMaxAmountHoldingDuringAtTime = (list, groupKey = 'YYYY') => {
    let holding = {};
    const format = 'YYYY-MM-DD';
    const direction = 'asc';
    let newList = [];

    list.forEach(entry => {
        const { buyDates = [], buyPrices = [], buyQties = [], sellDates = [], sellQties = [] } = entry;
        let totalBuyQty = 0;
        let totalBuyPrice = 0;
        buyDates.forEach((date, index) => {
            newList.push({ value: date, amount: formatValueWithType(buyPrices[index] * buyQties[index]) });
            const mapperKey = moment(date, format).format(groupKey);
            holding[mapperKey] = 0;
            totalBuyQty += buyQties[index];
            totalBuyPrice += formatValueWithType(buyPrices[index] * buyQties[index]);
        });

        let avgBuyPrice = formatValueWithType(totalBuyPrice / totalBuyQty);

        sellDates.forEach((date, index) => {
            newList.push({ value: date, amount: formatValueWithType(-1 * (avgBuyPrice * sellQties[index])) });
            const mapperKey = moment(date, format).format(groupKey);
            holding[mapperKey] = 0;
        });
    });

    newList.sort((a, b) => {
        const aDate = moment(a.value, format);
        const bDate = moment(b.value, format);
        if (!aDate.isValid() && !bDate.isValid()) return 0;
        if (!aDate.isValid()) return direction === 'asc' ? 1 : -1;
        if (!bDate.isValid()) return direction === 'asc' ? -1 : 1;

        return direction === 'asc' ? aDate - bDate : bDate - aDate;
    });

    let totalValue = 0;

    for (let tradeIndex = 0; tradeIndex < newList.length; tradeIndex++) {
        const { value = '', amount = 0 } = newList[tradeIndex];
        totalValue += amount;
        const mapperKey = moment(value, format).format(groupKey);
        holding[mapperKey] = formatValueWithType(totalValue);
        // if (holding[mapperKey] < totalValue)
        //     holding[mapperKey] = totalValue;
    }

    newList = Object.keys(holding).map(key => ({ key, value: formatValueWithType(holding[key]) }));

    newList.sort((a, b) => {
        const aDate = moment(a.key, groupKey);
        const bDate = moment(b.key, groupKey);
        if (!aDate.isValid() && !bDate.isValid()) return 0;
        if (!aDate.isValid()) return direction === 'asc' ? 1 : -1;
        if (!bDate.isValid()) return direction === 'asc' ? -1 : 1;

        return direction === 'asc' ? aDate - bDate : bDate - aDate;
    });

    return newList;
}

const getNumeric = (value, fallback = 0) => {
    const number = Number(value);
    return Number.isFinite(number) ? number : fallback;
}

const calculateCashLedger = (trades = []) => {
    const cashEvents = [];

    trades.forEach((trade) => {
        const {
            buyPrices = [],
            buyQties = [],
            buyDates = [],
            sellPrices = [],
            sellQties = [],
            sellDates = [],
            charges = {}
        } = trade;
        const { chargesSplit = {} } = charges;
        const { buy = [], sell = [] } = chargesSplit;

        buyDates.forEach((date, idx) => {
            if (!moment(date, 'YYYY-MM-DD', true).isValid()) return;
            const amount = getNumeric(buyPrices[idx]) * getNumeric(buyQties[idx], 1);
            if (amount > 0) cashEvents.push({ date, type: 'BUY', amount, tax: buy[idx].total ? getNumeric(buy[idx].total) : 0 });
        });

        sellDates.forEach((date, idx) => {
            if (!moment(date, 'YYYY-MM-DD', true).isValid()) return;
            const amount = getNumeric(sellPrices[idx]) * getNumeric(sellQties[idx], 1);
            if (amount > 0) cashEvents.push({ date, type: 'SELL', amount, tax: sell[idx].total ? getNumeric(sell[idx].total) : 0 });
        });

    });

    cashEvents.sort((a, b) => {
        const aDate = moment(a.date, 'YYYY-MM-DD');
        const bDate = moment(b.date, 'YYYY-MM-DD');
        if (aDate.isBefore(bDate)) return -1;
        if (aDate.isAfter(bDate)) return 1;
        if (a.type === b.type) return 0;
        return a.type === 'SELL' ? -1 : 1;
    });

    let runningDelta = 0;
    let minDelta = 0;
    let totalBuyOverall = 0;
    let totalSellOverall = 0;
    let totalTaxOverall = 0;

    cashEvents.forEach((event) => {
        if (event.type === 'BUY') {
            totalBuyOverall += event.amount;
            runningDelta -= event.amount;
        } else {
            totalSellOverall += event.amount;
            runningDelta += event.amount;
        }
        totalTaxOverall += event.tax;
        minDelta = Math.min(minDelta, runningDelta);
    });

    const minimumInitialCashRequired = Math.max(0, -minDelta);
    const finalCashHolding = minimumInitialCashRequired + runningDelta;

    return {
        totalBuyOverall: formatValueWithType(totalBuyOverall),
        totalSellOverall: formatValueWithType(totalSellOverall),
        totalTaxOverall: formatValueWithType(totalTaxOverall),
        minimumInitialCashRequired: formatValueWithType(minimumInitialCashRequired),
        finalCashHolding: formatValueWithType(finalCashHolding),
    };
}

const calculateCAGR = (initialValue, finalValue, startDate, endDate) => {
    const safeInitial = formatValueWithType(initialValue);
    const safeFinal = formatValueWithType(finalValue);
    if (!safeInitial || safeInitial <= 0 || !safeFinal || safeFinal <= 0) return 0;

    const timeInYears = moment(endDate).diff(moment(startDate), 'days') / 365.25;
    if (!timeInYears || timeInYears <= 0) return 0;

    const cagr = Math.pow(safeFinal / safeInitial, 1 / timeInYears) - 1;
    return formatValueWithType(cagr * 100);
}

const calculateXIRR = (cashFlows = []) => {
    if (!Array.isArray(cashFlows) || cashFlows.length < 2) return 0;

    const validFlows = cashFlows
        .map(({ date, amount }) => ({ date, amount: getNumeric(amount, 0) }))
        .filter(({ date, amount }) => moment(date, 'YYYY-MM-DD', true).isValid() && amount !== 0);

    if (validFlows.length < 2) return 0;

    const hasPositive = validFlows.some(flow => flow.amount > 0);
    const hasNegative = validFlows.some(flow => flow.amount < 0);
    if (!hasPositive || !hasNegative) return 0;

    const baseDate = moment.min(validFlows.map(flow => moment(flow.date, 'YYYY-MM-DD')));
    const yearFrac = (date) => moment(date, 'YYYY-MM-DD').diff(baseDate, 'days') / 365.25;
    const xnpv = (rate) => {
        if (rate <= -0.999999) return Number.POSITIVE_INFINITY;
        return validFlows.reduce((total, flow) => {
            const t = yearFrac(flow.date);
            return total + flow.amount / Math.pow(1 + rate, t);
        }, 0);
    };

    let low = -0.9999;
    let high = 10;
    let npvLow = xnpv(low);
    let npvHigh = xnpv(high);
    let attempts = 0;
    while (npvLow * npvHigh > 0 && attempts < 25) {
        high *= 2;
        npvHigh = xnpv(high);
        attempts++;
    }

    if (npvLow * npvHigh > 0) return 0;

    let mid = 0;
    for (let i = 0; i < 100; i++) {
        mid = (low + high) / 2;
        const npvMid = xnpv(mid);
        if (Math.abs(npvMid) < 1e-7) break;
        if (npvLow * npvMid < 0) {
            high = mid;
            npvHigh = npvMid;
        } else {
            low = mid;
            npvLow = npvMid;
        }
    }

    return formatValueWithType(mid * 100);
}

const formMetaData = (payload, meta) => {
    const {
        tradeList: originalTradeList = [],
    } = payload;
    if (originalTradeList.length === 0)
        return {};

    let tradeList = [...originalTradeList];

    const format = 'YYYY-MM-DD';
    const direction = 'asc';
    tradeList.sort((a, b) => {
        const aValue = a.buyDates[0] || '';
        const bValue = b.buyDates[0] || '';
        const aDate = moment(aValue, format);
        const bDate = moment(bValue, format);
        if (!aDate.isValid() && !bDate.isValid()) return 0;
        if (!aDate.isValid()) return direction === 'asc' ? 1 : -1;
        if (!bDate.isValid()) return direction === 'asc' ? -1 : 1;
        return direction === 'asc' ? aDate - bDate : bDate - aDate;
    })

    const firstCompleteTrade = tradeList.find(trade => trade.tradeCompleted);
    const completedTrades = tradeList.filter(trade => trade.tradeCompleted);
    const openTrades = tradeList.filter(trade => !trade.tradeCompleted);
    const { netProfitAfterTaxPercentage = 0 } = firstCompleteTrade || {};
    let minProfit = Number.MAX_SAFE_INTEGER, maxProfit = Number.MIN_SAFE_INTEGER, sumProfit = 0;
    const successCount = completedTrades.filter(trade => trade.netProfit > 0).length;
    const failureCount = completedTrades.filter(trade => trade.netProfit <= 0).length;
    const incompleteTradeCount = tradeList.length - successCount - failureCount;
    const successPercentage = formatValueWithType((successCount / tradeList.length) * 100);
    const completedTradeCount = successCount + failureCount;
    const totalInvested = formatValueWithType(completedTrades.reduce((accum, trade) => { return accum + trade.totalBuyAmount }, 0));
    const totalReturns = formatValueWithType(completedTrades.reduce((accum, trade) => { return accum + trade.totalSellAmount }, 0));
    const totalBrokerage = formatValueWithType(completedTrades.reduce((accum, trade) => { return accum + trade.charges.brokerage }, 0));
    const totalOtherChargesAndTax = formatValueWithType(completedTrades.reduce((accum, trade) => { return accum + trade.charges.otherChargesAndTax }, 0));
    const totalCapitalGainsTax = formatValueWithType(completedTrades.reduce((accum, trade) => { return accum + trade.charges.capitalGainsTax }, 0));
    const totalCharges = formatValueWithType(completedTrades.reduce((accum, trade) => { return accum + trade.totalCharges }, 0));
    const totalNetProfit = formatValueWithType(completedTrades.reduce((accum, trade) => { return accum + trade.netProfit }, 0));
    const totalInvestedOpen = formatValueWithType(openTrades.reduce((accum, trade) => { return accum + trade.totalBuyAmount }, 0));
    const totalCurrentValueOpen = formatValueWithType(openTrades.reduce((accum, trade) => { return accum + (trade.lastClosePrice * trade.quantity) }, 0));
    const totalBrokerageOpen = formatValueWithType(openTrades.reduce((accum, trade) => { return accum + trade.charges.brokerage }, 0));
    const totalOtherChargesAndTaxOpen = formatValueWithType(openTrades.reduce((accum, trade) => { return accum + trade.charges.otherChargesAndTax }, 0));
    const totalChargesOpen = formatValueWithType(openTrades.reduce((accum, trade) => { return accum + trade.totalCharges }, 0));
    const currentStockInvested = formatValueWithType(openTrades.reduce((accum, trade) => { return accum + (trade.avgBuyPrice * trade.quantity) }, 0));

    const successWithAverage = tradeList.filter(trade => trade.tradeCompleted && trade.isAveraged && trade.profitPercentage >= 0).length;
    const failureWithAverage = tradeList.filter(trade => trade.tradeCompleted && trade.isAveraged && trade.profitPercentage < 0).length;
    const inCompleteWithAverage = tradeList.filter(trade => !trade.tradeCompleted && trade.isAveraged).length;


    const firstTradeDate = tradeList[0]?.buyDates[0];
    const lastTradeDate = tradeList[tradeList.length - 1]?.buyDates[0];
    const cagrStartDate = moment(firstTradeDate, 'YYYY-MM-DD', true).isValid() ? firstTradeDate : moment().format('YYYY-MM-DD');
    const cagrEndDate = moment(lastTradeDate, 'YYYY-MM-DD', true).isValid() ? lastTradeDate : cagrStartDate;

    const cashLedger = calculateCashLedger(tradeList);
    const { totalBuyOverall = 0, totalSellOverall = 0, minimumInitialCashRequired = 0, finalCashHolding: currentCashInHand = 0,
        totalTaxOverall = 0
    } = cashLedger;
    const totalCurrentValueAtEnd = formatValueWithType(currentCashInHand + totalCurrentValueOpen);

    const investedCapital = minimumInitialCashRequired;
    const totalGrossProfit = formatValueWithType(getNumeric(totalReturns) - getNumeric(totalInvested));
    const hasOpenTrades = openTrades.length > 0;
    const valuationDate = moment().format('YYYY-MM-DD');
    const cashFlowsForXirr = [];
    const cashFlowsForNetXirr = [];

    tradeList.forEach((trade) => {
        const {
            quantity = 1,
            avgBuyPrice = 0,
            avgSellPrice = 0,
            buyPrices = [],
            buyQties = [],
            buyDates = [],
            sellPrices = [],
            sellQties = [],
            sellDates = [],
            charges = {},
        } = trade;
        const { chargesSplit = {} } = charges;
        const { buy = [], sell = [] } = chargesSplit;

        if (Array.isArray(buyDates) && Array.isArray(buyPrices) && Array.isArray(buyQties) && buyDates.length === buyPrices.length && buyPrices.length === buyQties.length && buyDates.length > 0) {
            buyDates.forEach((date, idx) => {
                if (!moment(date, 'YYYY-MM-DD', true).isValid()) return;
                const amount = getNumeric(buyPrices[idx]) * getNumeric(buyQties[idx], 1);
                const charges = buy[idx].total ? getNumeric(buy[idx].total) : 0;
                if (amount > 0) {
                    cashFlowsForXirr.push({ date, amount: -amount });
                    cashFlowsForNetXirr.push({ date, amount: -amount - charges });
                }
            });
        } else if (moment(buyDates[0], 'YYYY-MM-DD', true).isValid()) {
            const amount = getNumeric(avgBuyPrice) * getNumeric(quantity, 1);
            if (amount > 0) {
                cashFlowsForXirr.push({ date: buyDates[0], amount: -amount });
                cashFlowsForNetXirr.push({ date: buyDates[0], amount: -amount });
            }
        }

        if (Array.isArray(sellDates) && Array.isArray(sellPrices) && Array.isArray(sellQties) && sellDates.length === sellPrices.length && sellPrices.length === sellQties.length && sellDates.length > 0) {
            sellDates.forEach((date, idx) => {
                if (!moment(date, 'YYYY-MM-DD', true).isValid()) return;
                const amount = getNumeric(sellPrices[idx]) * getNumeric(sellQties[idx], 1);
                const charges = sell[idx].total ? getNumeric(sell[idx].total) : 0;
                if (amount > 0) {
                    cashFlowsForXirr.push({ date, amount });
                    cashFlowsForNetXirr.push({ date, amount: amount - charges });
                }
            });
        } else if (moment(sellDates[0], 'YYYY-MM-DD', true).isValid()) {
            const amount = getNumeric(avgSellPrice) * getNumeric(quantity, 1);
            if (amount > 0) {
                cashFlowsForXirr.push({ date: sellDates[0], amount });
                cashFlowsForNetXirr.push({ date: sellDates[0], amount });
            }
        }
    });

    if (hasOpenTrades && totalCurrentValueOpen > 0) {
        cashFlowsForXirr.push({ date: valuationDate, amount: getNumeric(totalCurrentValueOpen) });
        cashFlowsForNetXirr.push({ date: valuationDate, amount: getNumeric(totalCurrentValueOpen) });
    }
    const xirr = calculateXIRR(cashFlowsForXirr);
    const netXirr = calculateXIRR(cashFlowsForNetXirr);

    for (let index in tradeList) {
        const { netProfitPercentage = 0, tradeCompleted = false } = tradeList[index];
        if (tradeCompleted) {
            minProfit = Math.min(minProfit, netProfitPercentage);
            maxProfit = Math.max(maxProfit, netProfitPercentage);
            sumProfit += netProfitPercentage;
        }
    }
    const avgProfit = formatValueWithType(sumProfit / completedTradeCount);
    const completedProfitHoldingDayList = tradeList
        .filter((trade) => {
            if (!trade.tradeCompleted) return false;
            if (typeof trade.netProfitPercentage === 'number') return trade.netProfitPercentage >= 0;
            if (typeof trade.netProfit === 'number') return trade.netProfit >= 0;
            return false;
        })
        .map(trade => trade.holdingDays);
    const completedLossHoldingDayList = tradeList
        .filter((trade) => {
            if (!trade.tradeCompleted) return false;
            if (typeof trade.netProfitPercentage === 'number') return trade.netProfitPercentage < 0;
            if (typeof trade.netProfit === 'number') return trade.netProfit < 0;
            return false;
        })
        .map(trade => trade.holdingDays);
    const incompleteHoldingDayList = tradeList
        .filter(trade => !trade.tradeCompleted)
        .map(trade => {
            const { buyDates = [] } = trade;
            const buyMoment = moment(buyDates[0], 'YYYY-MM-DD');
            if (!buyMoment.isValid()) return 0;
            return Math.max(moment().startOf('day').diff(buyMoment.startOf('day'), 'days'), 0);
        });

    return {
        cagr: calculateCAGR(investedCapital, totalCurrentValueAtEnd, cagrStartDate, cagrEndDate),
        netCagr: calculateCAGR(investedCapital, totalCurrentValueAtEnd - totalTaxOverall, cagrStartDate, cagrEndDate),
        xirr, netXirr,
        successCount, failureCount, incompleteTradeCount,
        totalBuyOverall,
        totalInvestedOpen,
        totalCurrentValueOpen,
        totalBrokerageOpen,
        totalOtherChargesAndTaxOpen,
        totalCapitalGainsTax,
        totalChargesOpen,
        grossProfitOpen: formatValueWithType(getNumeric(totalCurrentValueOpen) - getNumeric(totalInvestedOpen)),
        netProfitOpen: formatValueWithType(getNumeric(totalCurrentValueOpen) - getNumeric(totalInvestedOpen) - getNumeric(totalChargesOpen)),
        totalSellOverall,
        minimumInitialCashRequired,
        currentCashInHand,
        currentStockInvested,
        totalCurrentValueAtEnd,
        totalInvested,
        totalReturns,
        totalGrossProfit,
        totalBrokerage,
        totalOtherChargesAndTax,
        totalCharges,
        totalNetProfit,
        successWithAverage, failureWithAverage, inCompleteWithAverage,
        holdingDaysGroupedProfit: groupHoldingSession(completedProfitHoldingDayList),
        holdingDaysGroupedLoss: groupHoldingSession(completedLossHoldingDayList),
        holdingDaysGroupedIncomplete: groupHoldingSession(incompleteHoldingDayList),
        totalTrades: tradeList.length, successPercentage,
        avgProfitPercentage: avgProfit, minProfitPercentage: minProfit,
        maxProfitPercentage: maxProfit,
        groupedByYear: groupDateWise(tradeList, 'YYYY'),
        groupedByMonth: groupDateWise(tradeList, 'MM-YYYY'),
        completedTradeList: completedTrades,
        openTradeList: openTrades,
        maxHoldingByDay: getMaxHoldingDuringATime(tradeList, 'DD-MM-YYYY'),
        maxHoldingAmountByDay: getMaxAmountHoldingDuringAtTime(tradeList, 'DD-MM-YYYY'),
        meta,
    }
}


export const applyStrategy = (requestPayload, listFormKey, requestConfig = {}) => {
    return async (dispatch, getState) => {
        dispatch({
            type: actionTypes.STRATEGY.APPLY_STRATEGY,
            payload: { strategyData: {}, listing: {}, metaData: {} },
        });
        const { forms = {} } = getState();
        const { formJson = {} } = forms;
        const formData = formJson[listFormKey] || {}
        let response = {};
        if (dummyResponse) {
            response = dummyResponseJson?.strategy_analysis_1 || Object.values(dummyResponseJson || {})[0] || {};
        } else {
            response = await getList(requestPayload, 'strategyAnlysis', undefined, requestConfig);
        }
        if (response?.meta?.cancelled) {
            return;
        }
        const { payload = {}, meta = {} } = response;
        const listing = formListJson(formData, payload, meta);
        const metaData = formMetaData(payload, meta);
        return dispatch({
            type: actionTypes.STRATEGY.APPLY_STRATEGY,
            payload: { strategyData: payload, listing, metaData },
        });
    }
};
